// extracted by mini-css-extract-plugin
export default {"clsInfoAlert":"src-app-components-InfoAlert-style__erb1N__clsInfoAlert"};